<!-- *ngIf="npInited" -->
<div class="modal-header">
    <h5 class="modal-title">주소검색</h5>
</div>
<div class="modal-body">

    <div #daum_search_address_iframe style="width: 100%; height: 500px; "
        [style.display]="form1.address1 ? 'none' : 'block'"></div>

    <form #ngForm1="ngForm" (ngSubmit)="ngForm1.valid && ngForm1Submit()" novalidate
        [style.display]="form1.address1 ? 'block' : 'none'">

        <h5>권역 & 위치정보</h5>
        <div class="row">
            <div class="col-7">
                <div class="np-form-table">
                    <div class="row">
                        <div class="col-12 td" npFcvName="area1">
                            <div class="cell-head">
                                <label class="np-fcv-label" for="form1_area1">권역1</label>
                            </div>
                            <div class="cell-content">
                                <input type="text" class="form-control" id="form1_area1" name="area1"
                                    [(ngModel)]="form1.area1" readonly required />
                                <np-fcv-error name="area1"></np-fcv-error>
                            </div>
                        </div>
                        <div class="col-12 td" npFcvName="area2">
                            <div class="cell-head">
                                <label class="np-fcv-label" for="form1_area2">권역2</label>
                            </div>
                            <div class="cell-content">
                                <input type="text" class="form-control" id="form1_area2" name="area2"
                                    [(ngModel)]="form1.area2" readonly required />
                                <np-fcv-error name="area2"></np-fcv-error>
                            </div>
                        </div>
                        <div class="col-12 td" npFcvName="area3">
                            <div class="cell-head">
                                <label class="np-fcv-label" for="form1_area3">권역3</label>
                            </div>
                            <div class="cell-content">
                                <input type="text" class="form-control" id="form1_area3" name="area3"
                                    [(ngModel)]="form1.area3" readonly required />
                                <np-fcv-error name="area3"></np-fcv-error>
                            </div>
                        </div>
                        <div class="col-12 td" npFcvName="zonecode">
                            <div class="cell-head">
                                <label class="np-fcv-label" for="form1_zonecode">우편번호</label>
                            </div>
                            <div class="cell-content">
                                <input type="text" class="form-control" id="form1_zonecode" name="zonecode"
                                    [(ngModel)]="form1.zonecode" readonly required />
                                <np-fcv-error name="zonecode"></np-fcv-error>
                            </div>
                        </div>
                        <div class="col-12 td" npFcvName="coordsY">
                            <div class="cell-head">
                                <label class="np-fcv-label" for="form1_coordsY">위도(latitude)</label>
                            </div>
                            <div class="cell-content">
                                <input type="text" class="form-control" id="form1_coordsY" name="coordsY"
                                    [(ngModel)]="form1.coords.y" readonly required />
                                <np-fcv-error name="coordsY"></np-fcv-error>
                            </div>
                        </div>
                        <div class="col-12 td" npFcvName="coordsX">
                            <div class="cell-head">
                                <label class="np-fcv-label" for="form1_coordsX">경도(longitude)</label>
                            </div>
                            <div class="cell-content">
                                <input type="text" class="form-control" id="form1_coordsX" name="coordsX"
                                    [(ngModel)]="form1.coords.x" readonly required />
                                <np-fcv-error name="coordsX"></np-fcv-error>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <div class="col" style="border: 1px solid gray; padding: 0.25rem;">
                <np-point-draggable-map [(point)]="form1.coords"
                    *ngIf="form1.coords && form1.coords.x && form1.coords.y"></np-point-draggable-map>
            </div>
        </div>
        <h5 class="mt-3">주소 및 상세주소</h5>
        <div class="np-form-table">
            <div class="row">
                <div class="col-12 td" npFcvName="address1">
                    <div class="cell-head">
                        <label class="np-fcv-label" for="form1_address1">주소1</label>
                    </div>
                    <div class="cell-content">
                        <input type="text" class="form-control" id="form1_address1" name="address1"
                            [(ngModel)]="form1.address1" placeholder="주소를 검색하세요." readonly required />
                        <np-fcv-error name="address1"></np-fcv-error>
                    </div>
                </div>
                <div class="col-12 td">
                    <div class="cell-head">
                        <label class="np-fcv-label" for="form1_address2">주소2(상세)</label>
                    </div>
                    <div class="cell-content">
                        <input type="text" class="form-control" id="form1_address2" name="address2"
                            [(ngModel)]="form1.address2" />
                    </div>
                </div>
            </div>
        </div>
    </form>
</div>

<div class="modal-footer">
    <button type="submit" class="btn btn-outline-secondary" (click)="searchAgain()" *ngIf="form1.address1">재검색</button>
    <div class="ms-auto d-flex gap-1">
        <button type="submit" class="btn btn-primary" (click)="ngForm1.onSubmit($event)" *ngIf="form1.address1" ngbAutofocus>확인</button>
        <button type="button" class="btn btn-secondary" (click)="activeModal.dismiss()">닫기</button>
    </div>
</div>